import { FetchService } from '@pib/api';
class AuthService {
    constructor() {
        this.fetchService = new FetchService();
    }
    getToken(type, code, tokenType, grandType = 'auth_code') {
        return this.fetchService.post(`/token/${tokenType}/${type}`, {
            grantType: grandType,
            authorizationCode: code,
        });
    }
    logout() {
        return this.fetchService.post('/token/logout');
    }
}
export default AuthService;
